var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qrcode-vue',{attrs:{"value":_vm.qrcodeUrl,"size":_vm.size,"level":"H","background":_vm.background,"foreground":_vm.foreground}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }